export default __webpack_public_path__ + "static/projectThree-d5066b7c659858f67b16f3c121381190.jpg";